import { format } from 'date-fns'
import React, { ChangeEvent, FC } from 'react'
import { DatePicker, RadioButton, SelectBox } from 'components/Form'
import { Spacer } from 'components/Utility'
import { PointCardExpiration, PointCardExpirationType, PointCardExpirationTypeMap } from 'types/pointCard'
import { SelectOption } from 'types/common'

type Props = {
  expiration: PointCardExpiration | null
  expirationType: PointCardExpirationType
  fromLastAcquiredPointDateOptions?: SelectOption[]
  fromAcquiredDateOptions?: SelectOption[]
  handleExpiresAt: (e: ChangeEvent<HTMLInputElement>) => void
  handleExpirationPeriod: (value: string) => void
  handleExpirationType: (type: PointCardExpirationType) => void
}

const PointCardExpirationForm: FC<Props> = (props) => {
  const {
    expiration,
    expirationType,
    fromAcquiredDateOptions,
    fromLastAcquiredPointDateOptions,
    handleExpiresAt,
    handleExpirationPeriod,
    handleExpirationType,
  } = props
  return (
    <>
      <RadioButton
        isChecked={expirationType === 'no_limit'}
        label={PointCardExpirationTypeMap['no_limit']}
        onChange={() => handleExpirationType('no_limit')}
        value={'no_limit'}
      />
      <Spacer size={12} />
      <RadioButton
        isChecked={expirationType === 'specified_date'}
        label={PointCardExpirationTypeMap['specified_date']}
        onChange={() => handleExpirationType('specified_date')}
        value={'specified_date'}
      />
      {expirationType === 'specified_date' && (
        <>
          <Spacer size={12} />
          <DatePicker
            onChange={handleExpiresAt}
            value={format(expiration?.expires_at?.toDate() ?? new Date(), 'yyyy-MM-dd')}
          />
        </>
      )}
      <Spacer size={12} />
      {fromAcquiredDateOptions && (
        <>
          <RadioButton
            isChecked={expirationType === 'from_acquired_date'}
            label={PointCardExpirationTypeMap['from_acquired_date']}
            onChange={() => handleExpirationType('from_acquired_date')}
            value={'from_acquired_date'}
          />
          {expirationType === 'from_acquired_date' && (
            <>
              <Spacer size={12} />
              <SelectBox
                options={fromAcquiredDateOptions}
                select={handleExpirationPeriod}
                value={expiration?.expiration_period?.toString() || '180'}
              />
            </>
          )}
        </>
      )}
      {fromLastAcquiredPointDateOptions && (
        <>
          <RadioButton
            isChecked={expirationType === 'from_last_acquired_point_date'}
            label={PointCardExpirationTypeMap['from_last_acquired_point_date']}
            onChange={() => handleExpirationType('from_last_acquired_point_date')}
            value={'from_last_acquired_point_date'}
          />
          {expirationType === 'from_last_acquired_point_date' && (
            <>
              <Spacer size={12} />
              <SelectBox
                options={fromLastAcquiredPointDateOptions}
                select={handleExpirationPeriod}
                value={expiration?.expiration_period?.toString() || '180'}
              />
            </>
          )}
        </>
      )}
    </>
  )
}

export default PointCardExpirationForm
